import * as disclaimerTypes from "./disclaimer.type";
import { API } from "../../../services/http.service";

const REQUEST_URL = "";

/**
 * Disclaimer accept/reject sonrası auth-service'in tracking kaydını güncellemesi için
 * çağrılır. Hata durumunda kullanıcı akışını engellemiyoruz — log eksik kalsa bile
 * portal flow'u devam etsin (best-effort tracking).
 *
 * status: "APPROVED" | "REJECTED" | "NOT_APPLICABLE"
 */
const updateLoginTrackingDisclaimerStatus = async (status) => {
  try {
    await API.post(`/auth/secure/login/disclaimer/status?status=${status}`);
  } catch (error) {
    // Log endpoint'i kritik değil; sessizce yutuyoruz, sadece console'a yaz
    console.warn("[disclaimer] tracking status update failed", error);
  }
};

/**
 * Login sonrası kullanıcının görmesi gereken disclaimer'ı (varsa) ve daha önce
 * kabul edilmiş olup olmadığını (checkedDisclaimerInTheWeek) backend'den alır.
 * - data == null veya checkedDisclaimerInTheWeek === true ise modal gösterilmez.
 * - data dolu ve checkedDisclaimerInTheWeek === false ise zorunlu modal açılır.
 */
export const getDisclaimerByEmployeeFirmId =
  (employeeFirmId) => async (dispatch) => {
    dispatch({ type: disclaimerTypes.GET_DISCLAIMER_PENDING });

    try {
      const response = await API.get(
        `${REQUEST_URL}/employee/disclaimer/${employeeFirmId}`
      );
      dispatch({
        type: disclaimerTypes.GET_DISCLAIMER_FULFILLED,
        payload: response,
      });
      return Promise.resolve(response);
    } catch (error) {
      dispatch({
        type: disclaimerTypes.GET_DISCLAIMER_REJECTED,
        payload: error,
      });
      return Promise.reject(error);
    }
  };

/**
 * Kullanıcı "Kabul Ediyorum" butonuna bastığında DisclaimerCheck kaydı oluşturur.
 * Backend dateRecord = now, dateRecordPlus = now + repromptAfterDays atar.
 *
 * Ek olarak: auth-service tracking kaydını da APPROVED olarak işaretle ki
 * admin Log Listeleme sayfasında "Disclaimer: Onayladı" görünsün.
 */
export const saveDisclaimerCheck = (disclaimerId) => async (dispatch) => {
  dispatch({ type: disclaimerTypes.SAVE_DISCLAIMER_CHECK_PENDING });

  try {
    const response = await API.post(
      `${REQUEST_URL}/employee/disclaimer/save`,
      { id: disclaimerId }
    );
    dispatch({
      type: disclaimerTypes.SAVE_DISCLAIMER_CHECK_FULFILLED,
      payload: response,
    });
    // Best-effort tracking — başarısız olursa bile kullanıcı akışını kesmiyoruz
    await updateLoginTrackingDisclaimerStatus("APPROVED");
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: disclaimerTypes.SAVE_DISCLAIMER_CHECK_REJECTED,
      payload: error,
    });
    return Promise.reject(error);
  }
};

/**
 * Reddetme akışı — Disclaimer page bu action'ı logout'tan ÖNCE dispatch eder.
 * Tracking'i REJECTED olarak işaretler (success=false + failureReason="Disclaimer onaylanmadı").
 * Logout sonrası JWT geçersiz olacağı için, mutlaka logout'tan ÖNCE çağrılmalı.
 */
export const markDisclaimerRejected = () => async () => {
  await updateLoginTrackingDisclaimerStatus("REJECTED");
};

export const resetDisclaimer = () => (dispatch) => {
  dispatch({ type: disclaimerTypes.RESET_DISCLAIMER });
};
